module.exports = __webpack_public_path__ + "static/media/icon-listo.506f7432.svg";